<div class="mode-switcher-modal-wrapper">
	<div>
		<ng-container>
			<app-kamona-loading
				[parentHeight]="'0'"
				[size]="40"
				[strokeWidth]="'2'">
			</app-kamona-loading>
		</ng-container>
	</div>
	<div>
		<div class="text-[#0B3275] text-center mt-[16px]">
			<div class="text-[16px] leading-[21px] font-normal not-italic">Switching</div>
			<div class="text-[16px] leading-[21px] font-semibold not-italic">
				{{businessName}}
			</div>
		</div>
	</div>
</div>
